import { useCallback, useEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import HelpTooltip from '../../../../components/tooltip/HelpTooltip'
import Loading from '../../../../components/loading/Loading'
import SelectBox from '../../../../components/form/SelectBox'
import { Link, useParams } from 'react-router-dom'
import PropTypes from 'prop-types'
import { fetchTrackerRights, setConversionTrackingId } from '../campaignSlice'
import ErrorText from '../../../../components/form/ErrorText'
import { useAlert } from '../../../dialog/Alert'

const ConversionTracking = ({ error, modify }) => {
  const dispatch = useDispatch()
  const { accountId: adAccountId } = useParams()
  const {
    form: { conversionTrackingId },
    trackerRight: {
      selected: { id: trackId, name: trackName, deleted: trackDeleted },
      content: trackerRights,
      isLoading: isTrackerRightLoading,
      hasError: trackerRightError,
    },
  } = useSelector(state => state.ad.campaign)
  const trackerPlaceholder = useMemo(
    () =>
      trackDeleted ? (
        <>
          <em className="fc_warn">[삭제됨]</em> {trackName} ({trackId})
        </>
      ) : (
        '연동하지 않기'
      ),
    [trackId, trackName, trackDeleted]
  )
  const [TrackDeletedAlert, showTrackDeletedAlert] = useAlert()

  useEffect(() => {
    dispatch(fetchTrackerRights())
  }, [dispatch, modify])
  useEffect(() => {
    if (trackDeleted) {
      showTrackDeletedAlert()
    }
  }, [trackDeleted, showTrackDeletedAlert])

  const handleChange = useCallback(
    value => dispatch(setConversionTrackingId(value)),
    [dispatch]
  )
  return (
    <>
      <div
        className={classNames('area_item', {
          error,
        })}>
        <strong className="subtit_box">전환추적</strong>
        <div className="cont_card">
          <div className="tit_card">
            <strong className="tit_detail">
              픽셀&amp;SDK 연동
              <HelpTooltip>
                전환추적을 위해서 픽셀&SDK 연동이 필요하며, 캠페인 단위로 설정할
                수 있습니다.
              </HelpTooltip>
            </strong>
          </div>
          <div className="item_card">
            {isTrackerRightLoading ? (
              <Loading />
            ) : trackerRightError === false ? (
              <SelectBox
                placeholder={trackerPlaceholder}
                noBlurOnDefault={trackDeleted || conversionTrackingId !== null}
                error={error}
                value={conversionTrackingId}
                onValueChange={handleChange}
                subTitle={
                  <>
                    픽셀&amp;SDK{' '}
                    <em className="fc_emph">{trackerRights.length}</em>
                  </>
                }>
                <SelectBox.Item value={null}>연동하지 않기</SelectBox.Item>
                {trackerRights.length > 0 &&
                  trackerRights.map(item => (
                    <SelectBox.Item key={item.trackId} value={item.trackId}>
                      {item.trackName} ({item.trackId})
                    </SelectBox.Item>
                  ))}
              </SelectBox>
            ) : (
              <p className="box_error">
                <span className="ico_comm" /> 일시적인 문제로 픽셀&amp;SDK를
                불러올 수 없습니다. 페이지를 새로고침 하세요.
              </p>
            )}
            <ErrorText error={error} tag="p" />
            <p className="desc_item">
              연동 가능한 대상은 광고자산 관리 &gt;{' '}
              <Link to={`/${adAccountId}/tracker`} className="fc_emph">
                픽셀&amp;SDK 연동 관리
              </Link>
              에서 추가할 수 있습니다.
            </p>
          </div>
        </div>
      </div>
      <TrackDeletedAlert title="픽셀&SDK 삭제됨">
        해당 캠페인에 설정된 픽셀&SDK가 삭제되어
        <br />
        더이상 정상적인 전환 추적이 불가합니다.
        <br />
        캠페인에서 사용 가능한 픽셀&SDK로 변경하세요.
      </TrackDeletedAlert>
    </>
  )
}
ConversionTracking.propTypes = {
  error: PropTypes.string,
  modify: PropTypes.bool,
}

export default ConversionTracking
